import { ROUTES } from '@/constants'
import { LANGUAGE_KEY } from '@/context/Locale/Locale'
import { ReleaseStatusEnum } from '@/rtkApi/mddApiSliceGeneratedV2'

export type DeploymentPackageRecord = {
	branchId: number
	branchName: string
	description: string
	id: string
	name: string
	owner: string
	status: ReleaseStatusEnum
}

export const STATUS_PILL: Record<
	ReleaseStatusEnum,
	{ background: string; color: string; labelKey: LANGUAGE_KEY }
> = {
	CANCEL: {
		background: '#FDECEA',
		color: '#C62828',
		labelKey: 'DEPLOYMENT_PACKAGES_STATUS_CANCEL',
	},
	COMPLETED: {
		background: 'rgba(31,73,84,0.10)',
		color: '#1F4954',
		labelKey: 'DEPLOYMENT_PACKAGES_STATUS_COMPLETED',
	},
	OPEN: {
		background: '#E6F4EA',
		color: '#0F9D58',
		labelKey: 'DEPLOYMENT_PACKAGES_STATUS_OPEN',
	},
}

export const DEPLOYMENT_PACKAGE_PAGE_SIZE = 200

export const getDeploymentPackagePath = (packageId?: string) =>
	packageId
		? ROUTES.DEPLOYMENT_PACKAGES_PACKAGE.replace(':packageId', packageId)
		: ROUTES.DEPLOYMENT_PACKAGES
